import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 5l10 14","key":"svg-0"}]]

const IconBackslash = createReactComponent('outline', 'backslash', 'Backslash', __iconNode);

export default IconBackslash;